import { useRef, useCallback } from 'react';
import { useResizeObserver } from './use-resize-observer';
export function useContainerQuery(mapFn, deps) {
    if (deps === void 0) { deps = []; }
    var elementRef = useRef(null);
    var refFn = useCallback(function () { return elementRef.current; }, [elementRef]);
    var memoizedMapFn = useCallback(function (entry, prevState) {
        var contentBox = entry.contentBoxSize[0];
        return mapFn({ width: contentBox.inlineSize, height: contentBox.blockSize }, prevState);
    }, deps);
    var state = useResizeObserver(refFn, memoizedMapFn);
    return [state, elementRef];
}
